import React, { useState } from 'react'

const isTestEnv = process.env.name === 'stage' || process.env.name === 'develop'

interface TokenVerifyTestProps {
  onTokenSubmit: (token: string, env: string) => void
}

// Default env for stage/local testing
const DEFAULT_TEST_ENV = 'stg-6'

const TokenVerifyTest: React.FC<TokenVerifyTestProps> = ({ onTokenSubmit }) => {
  const [manualToken, setManualToken] = useState('')

  if (!isTestEnv) {
    return null
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (manualToken.trim()) {
      onTokenSubmit(manualToken.trim(), DEFAULT_TEST_ENV)
    }
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        padding: '16px',
        backgroundColor: '#fff3cd',
        border: '1px solid #ffc107',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        zIndex: 9999,
        maxWidth: '300px',
      }}
    >
      <p
        style={{
          margin: '0 0 8px',
          fontWeight: 'bold',
          fontSize: '12px',
          color: '#856404',
        }}
      >
        🧪 Stage Testing Only
      </p>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={manualToken}
          onChange={(e) => setManualToken(e.target.value)}
          placeholder="Enter token..."
          style={{
            width: '100%',
            padding: '8px',
            marginBottom: '8px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            fontSize: '14px',
            boxSizing: 'border-box',
          }}
        />
        <button
          type="submit"
          style={{
            width: '100%',
            padding: '8px 16px',
            backgroundColor: '#ffc107',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: 'bold',
          }}
        >
          Verify Token
        </button>
      </form>
    </div>
  )
}

export default TokenVerifyTest
